module.exports = "//public.getcloudapp.com/packs/media/images/icons-add-bordered-1635b298730034509ab8bea32237cb1a.png";